import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Detail from "../pages/detail/page";
import ActorDetail from "../pages/actor/page";
import ActorList from "../pages/actors/page";
import Search from "../pages/search/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <Category /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "actor/:id", element: <ActorDetail /> },
      { path: "actors", element: <ActorList /> },
      { path: "search", element: <Search /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;